import { Component, computed, inject, input } from '@angular/core';
import type { LinkField, TextField } from '@core/jss-proxy';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { ReviewScoreComponent } from '@reviews/ui/score';
import { ReviewSingleComponent } from '@reviews/ui/single';
import { FieldService } from '@core/jss-utils';
import type { GetReviewsResponseWithStatistics } from '@integration/api-client/reviews';
import { NgClass } from '@angular/common';

@Component({
  selector: 'wl-reviews-entry-section',
  standalone: true,
  templateUrl: './reviews-entry-section.component.html',
  styleUrls: [
    './reviews-entry-section.component.ed.scss',
    './reviews-entry-section.component.essent.scss',
  ],
  imports: [
    CoreJssProxyModule,
    ReviewScoreComponent,
    ReviewSingleComponent,
    NgClass,
  ],
})
export class ReviewsEntrySectionComponent {
  readonly title = input<TextField>();
  readonly button = input<LinkField>();
  readonly reviews = input<GetReviewsResponseWithStatistics | undefined>();
  readonly showSummaryOnly = input<boolean>(false);

  readonly #fieldService = inject(FieldService);

  readonly showTitle = computed(() =>
    this.#fieldService.showTextField(this.title())
  );
}
